// apiConfig.ts

const isLocal =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

export const API_BASE_URL = isLocal
  ? "http://localhost:5005"
  : "https://notsticker-backend-1f08ac3d5994.herokuapp.com";
